import React from 'react';
import { useTranslation } from 'react-i18next';

import { useReferralAccess } from '../../../hooks/useReferralAccess';

import styles from './ReferralAccessBanner.module.scss';

const ReferralAccessBanner = ({ organization }) => {
  const { t } = useTranslation('common');
  const { blocked, pending, message, suspendedUntil, referralAccess } = useReferralAccess(organization);

  if (!blocked || pending) {
    return null;
  }

  const title =
    referralAccess?.status === 'suspended' ? t('referralAccess.suspendedTitle') : t('referralAccess.blockedTitle');

  return (
    <div className={styles.banner} role="status">
      <div className={styles.title}>{title}</div>
      <p className={styles.message}>{message}</p>
      {suspendedUntil && <p className={styles.until}>{t('referralAccess.suspendedUntil', { date: suspendedUntil })}</p>}
    </div>
  );
};

export default ReferralAccessBanner;
